<template>
  <div class="app-container" v-if="form">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" label-position="left">
      <el-card shadow="hover" class="form-card">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="批次名称" prop="batchName">
              <el-input
                  v-model="form.batchName"
                  placeholder="请输入批次名称"
                  style="width: 300px;"
                  maxlength="50"
                  show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="兑换码数量" prop="codeCount">
              <el-input-number
                  v-model="form.codeCount"
                  :min="1"
                  :step="1"
                  :precision="0"
                  placeholder="请输入数量"
                  style="width: 200px;"
                  @input="handleIntegerInput('codeCount')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="可兑换短剧数" prop="userLimit">
              <el-input-number
                  v-model="form.userLimit"
                  :min="1"
                  :step="1"
                  :precision="0"
                  placeholder="请输入数量"
                  style="width: 200px;"
                  @input="handleIntegerInput('userLimit')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="启用时间" prop="startTime">
              <el-date-picker
                  v-model="form.startTime"
                  type="datetime"
                  placeholder="选择启用时间"
                  style="width: 300px;"
                  :default-time="'00:00:00'"
                  value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                  v-model="form.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  style="width: 300px;"
                  :default-time="'23:59:59'"
                  value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>

    <el-card shadow="hover" class="drama-section">
      <div class="section-title">关联短剧</div>
      <el-button type="primary" icon="el-icon-plus" @click="openAddDramaDialog">添加短剧</el-button>

      <el-table :data="form.dramas || []" border style="margin-top: 20px">
        <el-table-column prop="id" label="短剧ID" width="120" />
        <el-table-column prop="videoName" label="短剧名称" />
        <el-table-column prop="coverUrl" label="短剧封面" width="120">
          <template slot-scope="scope">
            <el-image :src="scope.row.coverUrl" class="drama-cover" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="removeDrama(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="submit-footer">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>

    <el-dialog title="选择短剧" :visible.sync="dramaDialogVisible" width="600px">
      <el-form :inline="true" :model="dramaSearch" class="mb-2">
        <el-form-item label="短剧ID">
          <el-input v-model="dramaSearch.id" placeholder="输入ID" size="small" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="dramaSearch.name" placeholder="输入短剧名称" size="small" />
        </el-form-item>
        <el-button type="primary" size="small" @click="loadDramaList">搜索</el-button>
      </el-form>

      <el-table
          :data="availableDramas"
          @selection-change="handleDramaSelect"
          border
          style="width: 100%"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="短剧ID" width="100" />
        <el-table-column prop="videoName" label="短剧名称" />
        <el-table-column prop="coverUrl" label="短剧封面" width="120">
          <template slot-scope="scope">
            <el-image :src="scope.row.coverUrl" class="drama-cover" fit="cover" />
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          style="margin-top: 10px; text-align: right"
          layout="total, prev, pager, next"
          :total="dramaPagination.total"
          :current-page="dramaPagination.page"
          :page-size="dramaPagination.pageSize"
          @current-change="handleDramaPageChange"
      />

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dramaDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmAddDrama">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import dayjs from 'dayjs';

export default {
  data() {
    return {
      form: {
        batchName: '',
        codeCount: 1,
        userLimit: 1,
        startTime: null,
        endTime: null,
        dramas: [],
      },
      rules: {
        batchName: [{ required: true, message: '请输入批次名称', trigger: 'blur' }],
        codeCount: [{ required: true, message: '请输入兑换码数量', trigger: 'blur' }],
        userLimit: [{ required: true, message: '请输入用户兑换限制', trigger: 'blur' }],
        startTime: [
          { required: true, message: '请选择启用时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          { validator: this.validateEndTime, trigger: 'change' }
        ]
      },
      dramaDialogVisible: false,
      availableDramas: [],
      selectedDramas: [],
      dramaSearch: {
        id: '',
        name: ''
      },
      dramaPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  methods: {
    handleDramaSelect(selected) {
      this.selectedDramas = selected;
    },

    confirmAddDrama() {
      const existingIds = new Set(this.form.dramas.map(d => d.id));
      const newDramas = this.selectedDramas.filter(d => !existingIds.has(d.id));
      this.form.dramas.push(...newDramas);
      this.dramaDialogVisible = false;
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          this.$message.error('请检查表单信息');
          return;
        }

        if (this.form.dramas.length === 0) {
          this.$message.error('请至少关联一个短剧');
          return;
        }

        const payload = {
          convertName: this.form.batchName,
          codeCnt: this.form.codeCount,
          convertMax: this.form.userLimit,
          startTime: this.form.startTime, // 不再 formatDate
          endTime: this.form.endTime,     // 不再 formatDate
          videoIds: this.form.dramas.map(d => d.id)
        };

        request.post('/video/convertcombo/add', payload)
            .then(() => {
              this.$message.success('保存成功');
              this.$router.go(-1);
            })
            .catch(() => {
              this.$message.error('提交失败');
            });
      });
    },
    openAddDramaDialog() {
      this.dramaDialogVisible = true;
      this.resetDramaSearch();
      this.loadDramaList();
    },
    resetDramaSearch() {
      this.dramaSearch = { id: '', name: '' };
      this.dramaPagination.page = 1;
    },
    loadDramaList() {
      const params = {
        pageNum: this.dramaPagination.page,
        pageSize: this.dramaPagination.pageSize,
        id: this.dramaSearch.id,
        videoName: this.dramaSearch.videoName
      };
      request.get('/video/videos/page', { params }).then(res => {
        const records = res.data?.records || [];
        this.availableDramas = records.map(item => ({
          id: item.id,
          videoName: item.videoName,
          coverUrl: item.coverUrl // 默认中文封面，你也可以选 coverUrlEn、coverUrlCn 等
        }));
        this.dramaPagination.total = res.data.total || 0;
      });
    },
    handleDramaPageChange(newPage) {
      this.dramaPagination.page = newPage;
      this.loadDramaList();
    },
    removeDrama(index) {
      this.form.dramas.splice(index, 1);
    },
    handleIntegerInput(field) {
      const val = this.form[field];
      if (val && !Number.isInteger(val)) {
        this.form[field] = Math.floor(val); // 只保留整数部分
      }
    },
    validateEndTime(rule, value, callback) {
      const start = this.form.startTime;
      const end = value;

      if (!start || !end) {
        return callback(new Error('开始时间和结束时间不能为空'));
      }

      if (dayjs(end).isBefore(dayjs(start))) {
        return callback(new Error('结束时间不可早于开始时间'));
      }

      callback();
    }


  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background: #fff;
}
.section-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
.drama-cover {
  width: 80px;
  height: 80px;
  border-radius: 4px;
}
.submit-footer {
  margin-top: 30px;
  text-align: right;
}
</style>
